import { Link, useLocation } from "react-router-dom";

interface Props {
  role: "member" | "admin";
}

export function AdminChip({ role }: Props): JSX.Element | null {
  const location = useLocation();
  if (role !== "admin") return null;
  const isActive = location.pathname.startsWith("/admin");
  const base =
    "rounded-control px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary";
  const bg = isActive ? "bg-primary/20" : "bg-primary/10 hover:bg-primary/15";
  return (
    <Link
      to="/admin"
      className={`${base} ${bg}`}
      aria-current={isActive ? "page" : undefined}
    >
      Admin
    </Link>
  );
}
